function reSortDropInBlogMenu() {
  
  const this_url = window.location.href;
  
  if (this_url.indexOf("/a/hwb") == -1)
    return;	// only on hub pages
  
  
  let article_page = false;
  let menu = $("ul.dib-cat-menu");
  if (!menu.length) {
    article_page = true;
  	menu = $("#dib-template-2").prepend("<ul class='dib-cat-menu dib-single'></ul>");
  }

  $("ul.dib-cat-menu").html(`<li><a href="/pages/hwb/" data-alt-exact="https://www.thejoyformidable.com/a/hwb"><img src="//www.thejoyformidable.com/cdn/shop/t/2/assets/hub-hwb.png?v=8270158897346945641614993900"></a></li>
      				  	<li><a href="/a/hwb/category/our-story"><img src="//www.thejoyformidable.com/cdn/shop/t/2/assets/hub-story.png?v=83811134009505271591614993929"></a></li>
      					<li><a href="/a/hwb/category/tjf-daily"><img src="//www.thejoyformidable.com/cdn/shop/t/2/assets/hub-daily.png?v=99697095670848315031614993873"></a></li>
                        <li><a href="/a/hwb/category/music-club"><img src="//www.thejoyformidable.com/cdn/shop/t/2/assets/hub-club.png?v=39258762980676118701614993859"></a></li>
                        <li><a href="/a/hwb/category/c-mon-let-s-drift"><img src="//www.thejoyformidable.com/cdn/shop/t/2/assets/hub-drift.png?v=83763228212766978381614993886"></a></li>
                        <li><a href="/a/hwb/category/sonic"><img src="//www.thejoyformidable.com/cdn/shop/t/2/assets/hub-sonic.png?v=93106511424373256201614993915"></a></li>
                        <li><a href="/a/hwb/category/visual"><img src="//www.thejoyformidable.com/cdn/shop/t/2/assets/hub-visual.png?v=123483116468691360131614993955"></a></li>`);
  
  if (article_page)
  {
    // on article pages, match category 
    const cat_url = $("span.dib-post-category-text a").attr("href");
    $("ul.dib-cat-menu li a").each(function(){

      if (cat_url.includes($(this).attr('href')))
        $(this).addClass("current");
    });
    
  }
  else
  {
    $("ul.dib-cat-menu li a").each(function(){

      if (this_url.includes($(this).attr('href')) || this_url == ($(this).attr('data-alt-exact')) )
        $(this).addClass("current");
    });
  }

  $("ul.dib-cat-menu").css("display", "flex");
  
  
  $("#SiteNav li.site-nav__item:contains('HWB')").addClass("site-nav--active");
  
}


$(function() {
  
  	// if on vinyl-collection pages - default to vinyl variant.
  	if ($('div.single-album-header .breadcrumb:contains("Vinyl")').length) {
		$("select.single-select-field option:contains('Vinyl')").prop("selected", "selected");
  	}

  	// hack for auto-selecting Shopify plugin suggested language
  	$(document).bind("DOMNodeInserted", function(e) {	 
    	if (e.target.className == "locale-bar__container") {
      		$("button.locale-bar__button").trigger("click");
    	}
	});
  
  
  // disable special-alert

  reSortDropInBlogMenu();

 
});


